import { render, staticRenderFns } from "./PrognoseHeader.vue?vue&type=template&id=661fbd28&scoped=true"
import script from "./PrognoseHeader.vue?vue&type=script&lang=js"
export * from "./PrognoseHeader.vue?vue&type=script&lang=js"
import style0 from "./PrognoseHeader.vue?vue&type=style&index=0&id=661fbd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661fbd28",
  null
  
)

export default component.exports